import React from 'react';
import { Outlet } from 'react-router-dom';
import { ReactLenis } from 'lenis/react';
import 'lenis/dist/lenis.css';
import './css/style.css';

const PublicLayout = () => {
  return (
    <ReactLenis root options={{ lerp: 0.1, duration: 1.5, smoothWheel: true }}>
      <Outlet />
    </ReactLenis>
  );
};

export default PublicLayout;
